export const VERIFY_DETAIL_LOCALE = {
    vertifyTypeAll:'All',
    vertifyTypeError:'Error',
    vertifyTypeEmpty:'Empty'
};